import PropTypes from "prop-types";

import { AGGREGATE_TABLE_EMPHASIZED_COLUMN_KEYS } from "./constants";
import PricingReportPrintHtmlText from "./PricingReportPrintHtmlText";

export default function PricingReportPrintTable({ table }) {
  if (!table?.rows?.length) return null;

  const { title, rows, columns, footerNote } = table;

  return (
    <section className="pricing-report-print-table">
      {title ? (
        <PricingReportPrintHtmlText
          html={title}
          component="h2"
          className="pricing-report-print-table__title"
        />
      ) : null}
      <table className="pricing-report-print-table__table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id ?? rowIndex}>
              {columns.map((column) => {
                const rawValue = row[column.key];
                const cellValue =
                  typeof column.format === "function" ? column.format(rawValue, row) : rawValue ?? "";
                return (
                  <td
                    key={column.key}
                    className={
                      AGGREGATE_TABLE_EMPHASIZED_COLUMN_KEYS.has(column.key)
                        ? "pricing-report-print-table__cell--emphasized"
                        : undefined
                    }
                  >
                    {cellValue}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {footerNote ? <p className="pricing-report-print-table__footer">{footerNote}</p> : null}
    </section>
  );
}

PricingReportPrintTable.propTypes = {
  table: PropTypes.shape({
    title: PropTypes.string,
    rows: PropTypes.array,
    columns: PropTypes.array,
    footerNote: PropTypes.string,
  }),
};
